import React, { useContext } from 'react';
import { bool, func, number, element } from 'prop-types';
import classNames from 'classnames';

import { Row, Col, Image } from '@thd-olt-component-react/core-ui';

import { KeyProductFeatures } from '@thd-olt-component-react/key-product-features';

import { ProductRating } from '../product-rating/ProductRating';
import { ProductPodContext } from '../../ProductPodContext';
import { ProductImage } from '../product-image/ProductImage';
import { ProductHeader } from '../product-header/ProductHeader';
import { ProductPrice } from '../product-price/ProductPrice';
import { ProductATC } from '../product-atc/ProductATC';
import { ProductBadge } from '../product-badge/ProductBadge';
import { isATCEnabled } from '../../utils';
import { ProductQuoteCenter } from '../product-quote-center/ProductQuoteCenter';

import './product-mini.scss';

export const ProductMini = (props) => {

  const {
    disabled,
    onAction,
    enableATC,
    silentATC,
    onlyShowIfFulfillable,
    inCartQuantity,
    callToActionSection,
    showBadge,
    showBundleDiscount,
    showKPF
  } = props;

  const { product, isHDQCSku } = useContext(ProductPodContext);

  if (onlyShowIfFulfillable && !isATCEnabled(product)) {
    return null;
  }

  const { brandName, productLabel } = product.identifiers || {};

  const mainSectionClasses = classNames('product-pod-mini__main', {
    'product-pod-mini__main--withATC': enableATC
  });

  return (
    <div className="product-pod-mini">
      <div>
        {showBadge && (
          <div data-testid="product-pod-mini__badge">
            <ProductBadge badges={product.badges} />
          </div>
        )}
        <Col fallback="3" className="product-pod-mini__image">
          <ProductImage inCartQuantity={inCartQuantity} />
        </Col>
        <Col fallback="8" className={mainSectionClasses}>
          <ProductHeader brand="inline" collection="hidden" />
          <ProductRating />
          { isHDQCSku ? (
            <ProductQuoteCenter />
          ) : (
            <>
              {showBundleDiscount && (
                <div className="bundle-discount">
                  <Image
                    className="bundle-discount__icon"
                    asset="savings-tag.svg"
                    alt="Savings Tag"
                    title="Savings Tag"
                  />
                  <span className="bundle-discount__text">
                    Eligible for Bundle Discount
                  </span>
                </div>
              )}
              <ProductPrice large={false} hideBulkPrice />
              {enableATC && <ProductATC disabled={disabled} silent={silentATC} outline />}
            </>
          )}
          {showKPF && (
            <div data-testid="product-pod-mini__kpf" className="product-pod-mini__kpf">
              <KeyProductFeatures
                hideImage
                itemId={product.itemId}
                maxfeatures={5}
                simple
                oneColumnGrid
              />
            </div>
          )}
        </Col>
        <Col fallback="1" className="product-pod-mini__caret">
          {!isHDQCSku && (
            <Image
              onClick={onAction}
              className="product-pod-mini__caret__image"
              alt="caret"
              src="https://assets.thdstatic.com/images/v1/caret-orange.svg"
              width={9}
              height={15}
            />
          )}
        </Col>
      </div>
      {!enableATC && callToActionSection}
      <div />
    </div>
  );

};

ProductMini.displayName = 'ProductMini';

ProductMini.propTypes = {
  disabled: bool,
  onAction: func,
  enableATC: bool,
  silentATC: bool,
  onlyShowIfFulfillable: bool,
  inCartQuantity: number,
  callToActionSection: element,
  showBadge: bool,
  showBundleDiscount: bool,
  showKPF: bool
};

ProductMini.defaultProps = {
  disabled: false,
  onAction: () => {},
  enableATC: true,
  silentATC: false,
  onlyShowIfFulfillable: false,
  inCartQuantity: 0,
  callToActionSection: null,
  showBadge: false,
  showBundleDiscount: false,
  showKPF: false
};
